import { CONTENT_GROUP_ACTION } from "../constants";

const initialState = {
  isOpen: false,
  data: null, // id, workspace_id
  highlighted_comment: null, // {id, internal, cg_id}
};

export const card_popup_modal = (state = initialState, action) => {
  switch (action.type) {
    case CONTENT_GROUP_ACTION.OPEN_CARD_MODAL:
      return {
        ...state,
        isOpen: true,
        data: action.payload,
      };
    case CONTENT_GROUP_ACTION.CLOSE_CARD_MODAL:
      return {
        ...state,
        isOpen: false,
        data: null,
      };
    case CONTENT_GROUP_ACTION.SET_HIGHLIGHTED_COMMENT:
      return {
        ...state,
        highlighted_comment: action.payload,
      };
    case CONTENT_GROUP_ACTION.UNSET_HIGHLIGHTED_COMMENT:
      return {
        ...state,
        highlighted_comment: null,
      };
    default:
      return state;
  }
};